import Cache from 'root/cache';
import Util from 'root/module/util';
import $ from 'jquery';
import Modals from 'root/modals';
import View from 'view/base';
import Model_Feedback from 'model/feedback';

var Feedback_Merge = View.extend({
    primary_feedback_id: '',
    merge_feedbacks: [],
    initial_search_feedbacks: [],
    search_feedbacks: [],
    previous_search_feedback: [],
    project_id: null,

    className: 'feedback-merge',
    search_value: '',

    events: {
        'input .dropdown-search input'                 : 'onSearch',
        'click .dropdown li'                           : 'onSelect',
        'click button.dropdown-select .feedback-delete': 'onDelete',
        'click .dropdown .feedback-open'               : 'onFeedbackOpen',
        'click .suggest-duplicate'                     : 'onSuggestDuplicate',
        'click .suggest-duplicate-clear'               : 'onSuggestDuplicateClear',
        'click .account-upgrade'                       : 'onAccountUpgrade'
    },

    dom_handlers: {
        onAccountUpgrade: function() {
            Modals.choosePlan();
        },

        onSearch: function(e) {
            this.search_value = $(e.currentTarget).val().trim();

            if (this.search_timeout) {
                clearTimeout(this.search_timeout);
            }

            if (!this.search_value) {
                this.search_feedbacks = this.initial_search_feedbacks;

                this.renderFeedbackList();
                return;
            }

            this.search_timeout = setTimeout(() => {
                var data = {
                    search: this.search_value,
                    project_id: this.project_id
                };

                if (this.search_xhr) {
                    this.search_xhr.abort();
                }

                this.$el.find('.dropdown-feedback')
                    .html('')
                    .addClass('dropdown-search-empty')
                    .attr('data-empty', 'Loading...');

                this.search_xhr = Cache.app.request({
                    action: 'feedback/search',
                    data: data,
                    success: (response) => {
                        this.search_feedbacks = response.feedback.filter(item => item.id !== this.primary_feedback_id).map((item) => new Model_Feedback(item));
                        this.renderFeedbackList();
                    }
                });
            }, 300);
        },
        onSelect: function(e) {
            var id = parseInt($(e.currentTarget).data('id'));
            var index = this.merge_feedbacks.findIndex((model) => model.id === id);

            if (index === -1) {
                var feedback = this.search_feedbacks.find((model) => model.id === id);

                this.merge_feedbacks.push(feedback)
                $(e.currentTarget).addClass('selected');
            } else {
                this.merge_feedbacks = this.merge_feedbacks.filter((model) => model.id !== id);
                $(e.currentTarget).removeClass('selected');
            }

            var merge_feedback_ids = this.merge_feedbacks.map((model) => model.id);

            this.trigger('merged-feedback:change', merge_feedback_ids);
            this.renderSelectedFeedbacks();
        },
        onDelete: function(e) {
            var id = parseInt($(e.currentTarget).data('id'));
            var index = this.merge_feedbacks.findIndex((model) => model.id === id);

            if (index === -1) {
                return;
            }

            this.merge_feedbacks = this.merge_feedbacks.filter((model) => model.id !== id);

            var merge_feedback_ids = this.merge_feedbacks.map((model) => model.id);

            this.$el.find('.dropdown-feedback li[data-id="' + id + '"]').removeClass('selected');
            this.trigger('merged-feedback:change', merge_feedback_ids);
            this.renderSelectedFeedbacks();
        },
        onFeedbackOpen: function(e) {
            e.preventDefault();
            e.stopPropagation();
            var id = parseInt($(e.currentTarget).parents('li').data('id'));

            Modals.openFeedbackSidebar(id, 'sidebar', false);
        },
        onSuggestDuplicate: function(e) {
            e.preventDefault();

            this.$el.find('.dropdown-feedback')
                    .html('')
                    .addClass('dropdown-search-empty')
                    .attr('data-empty', 'Loading...');

            this.$el.find('.suggest-duplicate').hide();
            this.$el.find('.suggest-duplicate-clear').show();

            Cache.app.request({
                action: 'feedback/suggestDuplicate',
                data: {
                    feedback_id: this.primary_feedback_id,
                    min_score: 5,
                    include_merged: false
                },
                success: (response) => {
                    this.previous_search_feedback = this.search_feedbacks;
                    this.search_feedbacks = response.feedback.map((item) => new Model_Feedback(item));
                    this.renderFeedbackList('suggest');
                }
            });
        },
        onSuggestDuplicateClear: function(e) {
            this.$el.find('.suggest-duplicate').show();
            this.$el.find('.suggest-duplicate-clear').hide();

            this.search_feedbacks = this.previous_search_feedback;

            this.renderFeedbackList();
        },
    },

    initialize: function(options) {
        var merge_feedback_ids = options.initial_merge_feedback_ids || [];

        this.project_id = options.project_id;
        this.primary_feedback_id = options.primary_feedback_id;
        this.initial_search_feedbacks = options.initial_search_feedbacks || [];
        this.search_feedbacks = options.initial_search_feedbacks || [];
        this.merge_feedbacks = merge_feedback_ids.map((id) => Cache.feedback.get(id));
    },

    renderFeedbackList: function(type) {
        var feedback_items = '';

        if (this.search_feedbacks.length === 0) {
            this.$el.find('.dropdown-feedback').empty().addClass('dropdown-search-empty');
        } else {
            this.$el.find('.dropdown-feedback').removeClass('dropdown-search-empty');
        }

        var merge_feedback_ids = this.merge_feedbacks.map((model) => model.id);

        this.search_feedbacks.forEach((feedback) => {
            feedback_items +=
            '<li data-id="' + Util.htmlEntities(feedback.id) + '" class="' + (merge_feedback_ids.includes(feedback.id) ? 'selected' : '') + '">' +
                '<div class="flex-between">' +
                    '<div class="flex-start">' +
                        '<span class="feedback-id badge-id">' + feedback.id + '</span>' +
                        '<span class="feedback-type">' + feedback.getFeedbackTypeName(false) + '</span>' +
                    '</div>' +
                    '<div class="flex-start gap-8">' +
                        '<a href="#" class="feedback-open primary font-weight-medium"><i class="fa-solid fa-eye"></i> Preview</a>' +
                        '<span class="feedback-time text-info">' + Util.moment(feedback.get('time'), 'MMM DD') + '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="feedback-subject margin-top-4">' + Util.htmlEntities(feedback.getSubject()) + '</div>' +
                '<div class="feedback-description text-info margin-top-4">' + Util.htmlEntities(feedback.get('description')) + '</div>' +
            '</li>';
        });

        this.$el.find('.dropdown-feedback')
            .html(feedback_items)
            .attr('data-empty',type === 'suggest' ? 'No duplicates found' :  this.search_value ?  'No matches found' : 'Matched feedback will appear here');
    },

    renderSelectedFeedbacks: function() {
        var selected_html = this.merge_feedbacks
            .map((model) => {
                var text = Util.htmlEntities(model.getSubject());

                return '<span class="badge-primary-invert badge-small badge-btn font-weight-medium">' +
                            '<span>' + (text.length > 20 ? text.substring(0, 20) + '...' : text) + '</span>' +
                            '<button type="button" class="feedback-delete" data-id="' + model.id + '"><i class="far fa-times"></i></button>' +
                        '</span>';
            })
            .join('');

        if (!selected_html) {
            selected_html = '<span class="placeholder-text">No feedback selected</span>';
        }

        this.$el.find('button.dropdown-select').html(selected_html);
    },

    render: function() {
        var primary_feedback_subject = Cache.feedback.get(this.primary_feedback_id).getSubject();

        var content =
            '<form class="form-fluid">' +
                '<div class="row">' +
                    '<div class="field-label">Merge feedback into</div>' +
                    '<div class="box-small">' +
                        '<div class="flex-start">' +
                            '<div><span class="feedback-id badge-id">' + this.primary_feedback_id + '</span></div>' +
                            '<span class="feedback-type">' + Cache.feedback.get(this.primary_feedback_id).getFeedbackTypeName(false) + '</span>' +
                        '</div>' +
                        '<div class="margin-top-8 ellipsis">' + Util.htmlEntities(primary_feedback_subject) + '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Select feedback to merge</div>' +
                    '<div class="merge-feedback-dropdown button-dropdown button-dropdown-full button-dropdown-left dropdown-channel" data-autoclose="false">' +
                        '<button type="button" class="dropdown-select dropdown-select-multiple dropdown-select-medium"></button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" data-search="off" placeholder="Search for feedback ID, title or description">' +
                                '<button type="button" class="suggest-duplicate text-medium"><i class="fa-solid fa-wand-magic-sparkles margin-right-4"></i>Suggest duplicates</button>' +
                                '<button type="button" class="suggest-duplicate-clear text-medium"><i class="fas fa-times-circle margin-right-4"></i>Clear</button>' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select dropdown-feedback"></ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</form>' +
            (Cache.account.hasFeature('merge_feedback') ? '' :
            '<div class="margin-top-32 text-align-center">' +
                '<div class="text-info text-medium margin-bottom-12">This feature is not available in your plan.</div>' +
                '<button type="button" class="account-upgrade shiny medium"><span>Upgrade my plan</span></button>' +
            '</div>');

        this.$el.html(content);

        this.renderFeedbackList();
        this.renderSelectedFeedbacks();

        return this;
    },
});

export default Feedback_Merge;